function initRatingDescriptionShowMore() {
    if (!document.querySelector('.rating-item__description')) return;

    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('show-more-btn')) {
            const container = e.target.closest('.rating-item__description');

            const textBlock = container.querySelector('.text-collapsed');
            const button = container.querySelector('.show-more-btn');

            if (textBlock) {
                textBlock.classList.remove('text-collapsed');
            }

            if (button) {
                button.style.display = 'none';
            }
        }
    });
}

export default initRatingDescriptionShowMore;
